import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";
import { HoverCardShadow, HoverCardBorderLink } from "../styled/BPSCards";
import { BPSArrowLink, Arrow } from "../styled/Buttons";

import LogoACT from '../../assets/images/Sponsor - ACT.png';
import LogoNBDA from '../../assets/images/Sponsor - NBDA.png';
import LogoFosterLove from '../../assets/images/Sponsor - Foster Love.svg';
import LogoPeopleForBikes from '../../assets/images/Sponsor - People for Bikes.png';
import LogoT2T from '../../assets/images/Sponsor - T2T.png';

import RebateIcon from '../../assets/icons/BPS Icon - Rebate.png';
import ChannelIcon from '../../assets/icons/BPS Icon - Channel Incentives.png';
import RideshareIcon from '../../assets/icons/BPS Icon - Ridesharing.png';
import SalesContestIcon from '../../assets/icons/BPS Icon - Sales Contest.png';
import MarketResearchIcon from '../../assets/icons/BPS Icon - Market Research.png';
import EmployeeRewardsIcon from '../../assets/icons/BPS Icon - Employee Rewards.png';
import EbikeIcon from '../../assets/icons/BPS Icon - Ebike.png';
import CustomIncentiveIcon from '../../assets/icons/BPS Icon - Custom Incentives.png';
import RecallIcon from '../../assets/icons/BPS Icon - Recall & Warranty.png';
import SolarIcon from '../../assets/icons/BPS Icon - Solar.png';
import ReferralIcon from '../../assets/icons/BPS Icon - Referral.png';


const ProductCards1 = () => {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/channel-sales'>
                            <img src={ChannelIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Partner Up</h5>
                            <h3 className='fs-24'>Channel sales incentive system</h3>
                            <p>
                                Motivate dealers, distributors and channel partners with incentives that make your sales goals a reality.
                            </p>
                            <BPSArrowLink href='/channel-sales'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/sales-contests'>
                            <img src={SalesContestIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Up Swing</h5>
                            <h3 className='fs-24'>Sales contests solution</h3>
                            <p>
                                Drive sales through engaging and strategic sales contests that encourage healthy competition.
                            </p>
                            <BPSArrowLink href='/sales-contests'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/rebates'>
                            <img src={RebateIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Rebate Automater</h5>
                            <h3 className='fs-24'>Rebate program platform</h3>
                            <p>
                                Streamline your rebate program with our efficient platform.
                            </p>
                            <BPSArrowLink href='/rebates'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/referrals'>
                            <img src={ReferralIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Referral Pro</h5>
                            <h3 className='fs-24'>Referral program platform</h3>
                            <p>
                                Get more referrals and turn consumers into brand ambassadors.
                            </p>
                            <BPSArrowLink href='/referrals'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

const ProductCards2 = () => {
    return (
        <>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col lg={3} sm={6} className='my-2'>
                        <HoverCardBorderLink>
                            <img src={MarketResearchIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Market research</h3>
                            <p>
                                See more results at a higher quality with our market research solutions.
                            </p>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={6} className='my-2'>
                        <HoverCardBorderLink>
                            <img src={RideshareIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Rideshare programs</h3>
                            <p>
                                Incentivize commuters to use your rideshare programs.
                            </p>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={6} className="my-2">
                        <HoverCardBorderLink href='/ebike-incentives'>
                            <img src={EbikeIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Ebike Incentives</h3>
                            <p>
                                We have Ebike program options to support both dealers and municipalities.
                            </p>
                            <BPSArrowLink href='/ebike-incentives'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={6} className="my-2">
                        <HoverCardBorderLink className='col-md-2'>
                            <img src={SolarIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Solar incentives</h3>
                            <p>
                                Charge up your solar incentive program with our custom solutions.
                            </p>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={6} className="my-2">
                        <HoverCardBorderLink>
                            <img src={EmployeeRewardsIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Employee rewards</h3>
                            <p>
                                Motivate and reward your employees with an incentive program.
                            </p>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} sm={6} className="my-2">
                        <HoverCardBorderLink href='/payments'>
                            <img src={RecallIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Recall & warranty payments</h3>
                            <p>
                                Our payment solutions and automations take the stress out of the payments process.
                            </p>
                            <BPSArrowLink href='/payments'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                    <Col lg={3} className="my-2">
                        <HoverCardBorderLink href='/custom-incentive-programs'>
                            <img src={CustomIncentiveIcon} width={60} className="pb-2" />
                            <h3 className='fs-20'>Unique custom programs</h3>
                            <p>
                                When you need something specific, we’ll customize a solution that’s a perfect fit.
                            </p>
                            <BPSArrowLink href='/custom-incentive-programs'>Learn More <Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

const SponsorCards = () => {
    return (
        <>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col md={3} sm={4} xs={6} className="my-2">
                        <HoverCardBorderLink className='text-center' href='https://www.fosterlove.com/' target='_blank'>
                            <img src={LogoFosterLove} width='100%' alt="Foster Love" className="my-auto" />
                        </HoverCardBorderLink>
                    </Col>
                    <Col md={3} sm={4} xs={6} className="my-2">
                        <HoverCardBorderLink className='text-center' href='https://www.peopleforbikes.org/' target='_blank'>
                            <img src={LogoPeopleForBikes} width='100%' alt="People for Bikes" className="my-auto" />
                        </HoverCardBorderLink>
                    </Col>
                    <Col md={3} sm={4} xs={6} className="my-2">
                        <HoverCardBorderLink className='text-center' href='https://tunneltotowers-t2t.org/' target='_blank'>
                            <img src={LogoT2T} width='100%' alt="T2T" />
                        </HoverCardBorderLink>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col md={3} sm={4} xs={6} className="my-2">
                        <HoverCardBorderLink className='text-center' href='https://www.actweb.org/' target='_blank'>
                            <img src={LogoACT} width='100%' alt="ACT" />
                        </HoverCardBorderLink>
                    </Col>
                    <Col md={3} sm={4} xs={6} className="my-2">
                        <HoverCardBorderLink className='text-center' href='https://nbda.com/#!event-list' target='_blank'>
                            <img src={LogoNBDA} width='100%' alt="NBDA" />
                        </HoverCardBorderLink>
                    </Col>
                </Row>
            </Container>

        </>
    );
}


export { ProductCards1, ProductCards2, SponsorCards }
